import { useState, useEffect } from "react";

export const useBusinessType = () => {
  const [businessType, setBusinessType] = useState<string>("");

  useEffect(() => {
    const type = sessionStorage.getItem("business_type") || "";
    setBusinessType(type);
  }, []);

  return businessType;
};